module.exports = __webpack_public_path__ + "static/media/9DESA15.90741d7f.jpg";